import React, { Component } from 'react';

class MapsHelpers extends Component {

    constructor(props) {
        super(props);
        this._handleFindMyLocation = this._handleFindMyLocation.bind(this);
        this._handleSwitchMapTypes = this._handleSwitchMapTypes.bind(this);
    }

    _handleFindMyLocation() {
        this.props.findMyLocation();
    }

    _handleSwitchMapTypes() {
        this.props.switchMapTypes();
    }

    render() {
        return (
            <div className="MapsHelpers">
                <div className="button is-black is-circle is-shadow" onClick={this._handleFindMyLocation}>
                    <span className="icon has-text-primary"><img src="/Images/locate.png" alt="user location"></img></span>
                </div>
                <div className="button is-black is-circle is-shadow" onClick={this._handleSwitchMapTypes}>
                    <span className="icon has-text-primary"><img src="/Images/maptype.png" alt="Switch map type"></img></span>
                </div>
            </div>
        );
    }

}

export default MapsHelpers;


// WEBPACK FOOTER //
// ./src/PageMaps/_MapsHelpers.js